import { LatLng } from 'leaflet'
import notify from '~/utils/notify'
import type { updateDeviceGroupChangeProps } from '../TabListDevice/interfaces/IListDeviceTab'
import { Downgraded } from '@hookstate/core'
import { v4 as uuidv4 } from 'uuid';

// eslint-disable-next-line max-lines-per-function
export default function deviceSocket({
  message,
  dispatch,
  updateStatusVehicleListInDispatch,
  updateListAllVehicles,
  updateListAllNoPaginationVehicles,
  updateMarker,
  updateVehicleListInDispatch,
  createMarker,
  getMarker,
  translate,
  user,
  updateStatusDeviceRowsTable,
  updateCurrentDispatchDeviceTable,
  updateTransferDeviceRowsTable,
  updateDeviceGroupChange,
  dispatchGroupView,
  updateNewDeviceCreated,
  getListDevicesDisconnects,
  agencyIdFilterMap,
  operationIdFilterMap,
  actualNotification,
  enableButtonShowResumeTransferMultiple,
  getListDevicesMultiplesTransfer,
  syncDispatchFromId,
  verifyPermission,
}) {
  if (message.event_type != 'DEVICE_POSITION_CHANGED')

  if (message.event_type === 'DISPATCH_DEVICE_STATUS_CHANGE') {
    if (message.content.status_changed_by_mobile) {
      notify({
        idMessage: uuidv4(),
        type: 'info',
        message: `${translate('Device:name')} ${message.content.device_name} atualizou status de ${message.content.code} - ${message.content.current_status?.name || message.content.current_status} `,
          clickableMessage: {
            id: message.content.dispatch_id,
            urlRedirection: '/dispatch',
            action: () => syncDispatchFromId(message.content.dispatch_id),
            hideButton: verifyPermission(['dispatch_index']) ? false : true,
          },
          autoCloseDuration: 10000,
          actualNotification: actualNotification
      })
    }
    
    if (dispatch().id.get() == message.content.dispatch_id) {
      try {
        
        updateStatusVehicleListInDispatch({
          dispatchDeviceId: message.content.dispatch_device_id,
          status: message.content.current_status,
          dateUpdated: message.content.current_date,
        })
      } catch (error) {
        console.error(
          `Erro atualizando lista dos veículos no despacho atual ${JSON.stringify(
            message
          )} - ${JSON.stringify(error)}`
        )
      }
    }

    try {
      updateListAllVehicles({
        deviceId: message.content.device_id,
        dispatchStatus: message.content.current_status,
      })
    } catch (error) {
      console.error(
        `Erro atualizando lista dos veículos da tela de suporte ${JSON.stringify(
          message
        )} - ${JSON.stringify(error)}`
      )
    }

    try {
      updateListAllNoPaginationVehicles({
        deviceId: message.content.device_id,
        dispatchStatus: message.content.current_status,
      })
    } catch (error) {
      console.error(
        `Erro atualizando lista dos veículos da tela de suporte ${JSON.stringify(
          message
        )} - ${JSON.stringify(error)}`
      )
    }

    try {
      if (message.content.current_dispatch_status) {
        updateCurrentDispatchDeviceTable({
          dispatchId: message.content.dispatch_id,
          deviceId: message.content.device_id,
          currentDispatchStatus: message.content.current_dispatch_status,
        })
      }
    } catch (error) {
      console.error(
        `Erro atualizando lista dos veículos da tela de suporte ${JSON.stringify(
          message
        )} - ${JSON.stringify(error)}`
      )
    }
  }
  if (message.event_type === 'DEVICE_POSITION_CHANGED') {
    try {
      if (message.content.latitude && message.content.longitude) {
        const params = {
          id: message.content?.device_id,
          markerId: `device-${message.content?.device_id}`,
          code: message.content?.code,
          position: new LatLng(
            message.content.latitude,
            message.content.longitude
          ),
          status: message.content?.device_status_id,
          identifier: message.content?.identifier,
          speed: message.content?.speed ? message.content?.speed : 0,
          plate: message.content?.plate ? message.content?.plate : '',
          date: message.content?.date ? message.content?.date : '',
          groupId: message.content?.group_id,
          isCurrent: false,
          deviceType: message.content?.device_type ? message.content?.device_type : null,
          agencyName: message.content?.agency_name ? message.content?.agency_name : null,
        }
        if (window.location.pathname !== '/dispatch/management-map') {
          createMarker({
            markerType: 'device',
            markerIdentifier: message.content.device_id,
            ...(params as any),
          })
        } else {
          updateMarker({
            markerType: 'device',
            markerIdentifier: message.content.device_id,
            attribute: 'position',
            value: new LatLng(message.content.latitude, message.content.longitude)
          })
          updateMarker({
            markerType: 'device',
            markerIdentifier: message.content.device_id,
            attribute: 'status',
            value: message.content.device_status_id
          });
        }
      }
    } catch (error) {
      console.error(
        `Erro atualizando posição das viaturas ${JSON.stringify(
          message
        )} - ${JSON.stringify(error)}`
      )
    }
  }

  if (message.event_type === 'DEVICE_STATUS_CHANGE') {
    if (message.content?.current_status?.id) {
      try {

        const currentMarker = getMarker({
          markerType: 'device',
          markerIdentifier: message.content.device_id,
        })
        if (currentMarker) {
          updateMarker({
            markerType: 'device',
            markerIdentifier: message.content.device_id,
            attribute: 'status',
            value: message.content.current_status.id,
          })
        }
      } catch (error) {
        console.error(
          `Erro atualizando marcador de veículo ${JSON.stringify(
            message
          )} - ${error}`
        )
      }
    }
    try {
      updateListAllVehicles({
        deviceId: message.content.device_id,
        dispatchStatus: message.content.current_status,
      })
    } catch (error) {
      console.error(
        `Erro atualizando lista de veículos ${JSON.stringify(
          message
        )} - ${JSON.stringify(error)}`
      )
    }

    try {
      updateListAllNoPaginationVehicles({
        deviceId: message.content.device_id,
        dispatchStatus: message.content.current_status,
      })
    } catch (error) {
      console.error(
        `Erro atualizando lista de veículos ${JSON.stringify(
          message
        )} - ${JSON.stringify(error)}`
      )
    }

    try {
      if (message.content.device_id) {
        updateStatusDeviceRowsTable({
          deviceId: message.content.device_id,
          deviceName: message.content.name,
          dispatchGroup: message.content.dispatch_group,
          dispatch: message.content.dispatch,
          outOfService: message.content.out_of_service,
          previousStatus: message.content.previous_status,
          currentStatus: message.content.current_status,
          deviceLog: message.content.device_log,
          onMission: message.content.on_mission
        })
      }
    } catch (error) {
      console.error(
        `Erro atualizando lista de veículos ${JSON.stringify(
          message
        )} - ${JSON.stringify(error)}`
      )
    }
  }
  if (message.event_type === 'DEVICE_DISPATCH_GROUP_CHANGE') {
    try {
      updateTransferDeviceRowsTable({
        deviceId: message.content.device_id,
        destinyDispatchGroupId: message.content.destiny_dispatch_group.id,
      })
    } catch (error) {
      console.error(
        `Erro atualizando lista de veículos ${JSON.stringify(
          message
        )} - ${JSON.stringify(error)}`
      )
    }

    if (window.location.pathname == '/dispatch/management-map' && (agencyIdFilterMap || operationIdFilterMap) && (message.content.current_status.id == 1)) {
      if (agencyIdFilterMap === message.content.agency_id || operationIdFilterMap === message.content.device_log.operation_id) {
        updateMarker({ markerType: 'device', markerIdentifier: message.content.device_id, attribute: 'status', value: message.content.current_status.id });
      }

    }
  }
  if (message.event_type === 'DISPATCH_ASSOCIATE_DEVICE') {
    if (message.content.dispatch_id === dispatch().id.get() && message.content.user_id !== user) {
      try {
        updateVehicleListInDispatch({ deviceSocketData: message.content })
        notify({
          type: 'info',
          message: `${translate('The device was associated with the dispatch', {
            deviceName: message.content.device.name,
          })}`,
          actualNotification: actualNotification
        })
      } catch (error) {
        console.error(
          `Erro atualizando lista de veículos ${JSON.stringify(
            message
          )} - ${JSON.stringify(error)}`
        )
      }
    }
  }

  if (message.event_type === 'MULTIPLE_DISCONNECTION_COMPLETED') {
    message.content.map((device) => {
      return getListDevicesDisconnects(device)
    })

    notify({
      message: `${translate('Multiple disconnection executed successfully!')}`,
      type: 'success',
    })
  }

  if (message.event_type === 'DEVICE_MULTIPLE_DISCONNECTED') {
    const userSocket = message.content.user_id

    if (userSocket != user) {
      message.content.devices?.map((device) => {
        if (!device.error.length) {
          notify({
            type: 'info',
            message: `${translate('The vehicle was deconnected in batch', {
              vehicle: device.device,
            })}`,
            actualNotification: actualNotification
          })
        }
      })
    }
  }

  if (message.event_type === 'DEVICE_DISPATCH_GROUP_CHANGE') {
    const dispatchGroupViewLocal = JSON.parse(
      JSON.stringify(dispatchGroupView().attach(Downgraded).get())
    )
    const groupVisibles = Object.keys(dispatchGroupViewLocal).filter((item) =>
      dispatchGroupView()[item].is_visible.get()
    )
    const hasAccessToDestinyGroup = groupVisibles.includes(
      message.content.destiny_dispatch_group.name
    )
    updateDeviceGroupChange({
      deviceId: message.content.device_id,
      deviceName: message.content.destiny_name,
      hasAccessToDestinyGroup: hasAccessToDestinyGroup,
      deviceLog: message.content.device_log,
      destinyDispatchGroup: message.content.destiny_dispatch_group,
      currentStatus: message.content.current_status,
    })
  }

  if (message.event_type === 'DEVICE_CREATED') {
    updateNewDeviceCreated({
      deviceId: message.content.id,
      deviceName: message.content.name,
      currentStatus: message.content.current_status,
      deviceLog: message.content.device_log,
      dispatchGroup: message.content.dispatch_group
    })
  }

  if (message.event_type === 'MULTIPLE_DEVICE_TRANSFER_COMPLETED') {
    const userSocket = message.content.user_id
    const successTransfer = message.content.filter((device) => !device.error.length)
    const existError = message.content.filter((device) => device.error.length)

    message.content?.map((device) => getListDevicesMultiplesTransfer(device))

    if (successTransfer.length > 0) {
      notify({
        type: 'info',
        message: `${translate('Devices transferred with success', { number: successTransfer.length})}`,
        actualNotification: actualNotification
      })
    }

    if (existError.length > 0) {
      notify({
        type: 'error',
        message: `${translate('One or more errors occurred while transferring devices', { number: existError.length })}`,
        actualNotification: actualNotification
      })
    }
    enableButtonShowResumeTransferMultiple.set(true)

  }
}
